import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import DebugConfigPanel from "./components/DebugConfigPanel";
import HomePage from "./components/Home/HomePage";
import Checkout from "./components/Order/Checkout";
import OrderConfirmation from "./components/OrderConfirmation";
import { ToysProvider } from "./components/Toy/ToysContext";
import { ConfigProvider } from "./config/ConfigContext";
import { isAppDebug } from "./utils/isAppDebug";

export default function AppWrapper() {
  return (
    <ConfigProvider>
      <ToysProvider>
        <BrowserRouter>
          <Helmet>
            <title>Water Toys — Rental</title>
          </Helmet>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/confirmation" element={<OrderConfirmation />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ToysProvider>
      {isAppDebug() ? <DebugConfigPanel /> : null}
    </ConfigProvider>
  );
}
